import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PhotoStudioPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Photo Studio | L+TV TÉLÉVISION";
  }, []);

  const services = [
    { title: t("studio.svc.portrait.title"), description: t("studio.svc.portrait.desc"), icon: "ri-user-smile-line" },
    { title: t("studio.svc.event.title"), description: t("studio.svc.event.desc"), icon: "ri-camera-line" },
    { title: t("studio.svc.studio.title"), description: t("studio.svc.studio.desc"), icon: "ri-lightbulb-line" },
    { title: t("studio.svc.commercial.title"), description: t("studio.svc.commercial.desc"), icon: "ri-briefcase-line" },
  ];

  const galleryImages = [
    "https://readdy.ai/api/search-image?query=Professional%20portrait%20photography%20session%20in%20modern%20studio%20with%20soft%20lighting%2C%20editorial%20style%20headshot%20setup%2C%20warm%20neutral%20background&width=400&height=300&seq=photo-1&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Wedding%20event%20photography%20candid%20moment%2C%20elegant%20African%20celebration%2C%20warm%20natural%20lighting%2C%20editorial%20photography%20style&width=400&height=300&seq=photo-2&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Professional%20product%20photography%20setup%20in%20studio%20with%20clean%20white%20background%2C%20modern%20lighting%20equipment%2C%20editorial%20style&width=400&height=300&seq=photo-3&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Family%20portrait%20session%20in%20professional%20studio%2C%20warm%20natural%20lighting%2C%20happy%20family%20posing%2C%20editorial%20photography%20style&width=400&height=300&seq=photo-4&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Corporate%20event%20photography%20conference%20room%20setup%2C%20professional%20business%20gathering%2C%20editorial%20photography%20style&width=400&height=300&seq=photo-5&orientation=landscape",
    "https://readdy.ai/api/search-image?query=Professional%20fashion%20photography%20studio%20setup%20with%20model%20posing%2C%20dramatic%20lighting%2C%20editorial%20photography%20style&width=400&height=300&seq=photo-6&orientation=landscape",
  ];

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("studio.title")}</h1>
          <p className="text-white/60 text-sm mt-1">{t("studio.subtitle")}</p>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        {/* Hero Section */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-foreground-700 leading-relaxed text-lg">
            {t("studio.intro")}
          </p>
        </div>

        {/* Services */}
        <h2 className="ltv-section-title">{t("studio.servicesTitle")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-12">
          {services.map((s) => (
            <div key={s.title} className="bg-white rounded-lg border border-background-200 p-5 text-center">
              <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center text-primary-600 mx-auto mb-3">
                <i className={`${s.icon} text-xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-900 mb-2">{s.title}</h3>
              <p className="text-sm text-foreground-600">{s.description}</p>
            </div>
          ))}
        </div>

        {/* Gallery */}
        <h2 className="ltv-section-title">{t("studio.portfolio")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
          {galleryImages.map((src, i) => (
            <div key={i} className="rounded-lg overflow-hidden aspect-[4/3]">
              <img src={src} alt={`Photo ${i + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="bg-primary-50 rounded-lg border border-primary-100 p-8 text-center">
          <h3 className="text-lg font-bold text-primary-900 mb-2">{t("studio.ctaTitle")}</h3>
          <p className="text-sm text-primary-700 mb-4">{t("studio.ctaDesc")}</p>
          <Link to="/contact" className="ltv-btn-accent text-sm inline-flex items-center gap-2">
            {t("studio.contactUs")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}